<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 6.98318C0.999832 6.99377 0.999832 7.00436 1 7.01493V18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V7.01495C23.0002 7.00436 23.0002 6.99377 23 6.98317V6C23 4.34315 21.6569 3 20 3H4C2.34315 3 1 4.34315 1 6V6.98318ZM3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6V6.45063L12.4991 11.8526L12.4968 11.854C12.3478 11.9468 12.1756 11.996 12 11.996C11.8244 11.996 11.6522 11.9468 11.5032 11.854L3 6.45063V6ZM21 8.82027V18C21 18.5523 20.5523 19 20 19H4C3.44772 19 3 18.5523 3 18V8.82028L10.4337 13.544L10.4391 13.5474C10.9069 13.8405 11.4479 13.996 12 13.996C12.5521 13.996 13.0931 13.8406 13.5609 13.5474L21 8.82027Z"
    />
  </svg>
</template>
